import React, { ReactElement } from 'react';
import { renderRoutes, RouteConfig } from 'react-router-config';
import { SelfOnboardingLayoutProps } from 'layouts/selfOnboarding/types';

export function SelfOnboardingLayout(
  props: SelfOnboardingLayoutProps,
): ReactElement {
  const { route } = props;

  return <div>{renderRoutes(route.routes as RouteConfig[])}</div>;
}
